import { render, staticRenderFns } from "./RoleDropdown.vue?vue&type=template&id=2d6aefbc&scoped=true&"
import script from "./RoleDropdown.vue?vue&type=script&lang=js&"
export * from "./RoleDropdown.vue?vue&type=script&lang=js&"
import style0 from "./RoleDropdown.vue?vue&type=style&index=0&id=2d6aefbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6aefbc",
  null
  
)

export default component.exports